module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - CONTACT")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_email')) + " cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-13917648345")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_mobile')) + "13917648345")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_2')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-533-7525879")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_fax')) + " 0086-533-7484168")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_3')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-21-58569507")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" " + _vm._s(_vm.$t('contact_fax')) + " 0086-21-58201568")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "margin-top": "20px"
    }
  }, [_c('contact')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1559bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactus.vue
// module id = 417
// module chunks = 1